import { render } from "./CarteSalle.vue?vue&type=template&id=cf36b778"
import script from "./CarteSalle.vue?vue&type=script&lang=js"
export * from "./CarteSalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__